"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var ModuleLink = /** @class */ (function (_super) {
                __extends(ModuleLink, _super);
                function ModuleLink() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ModuleLink.prototype.render = function () {
                    var classes = "modulesFlyout-link";
                    classes += (this.props.Last && !this.props.isSummary) ? " modulesFlyout-last" : "";
                    classes += (this.props.Level > 1 && !this.props.isSummary) ? " modulesFlyout-indent" : "";
                    classes += (this.props.Favorite) ? " modulesFlyout-isFavorite" : "";
                    classes += (this.props.isSummary) ? " modulesFlyout-linkDivider" : "";
                    var path;
                    if (this.props.isSummary) {
                        path = this.getCrumbElement(true);
                    }
                    return (React.createElement("div", { "aria-label": this.props.Label, className: classes, "data-dyn-selected": this.props.Selected, onClick: this.handleClick, onKeyDownCapture: this.keyHandler, role: "link", tabIndex: -1 },
                        React.createElement("a", { className: "modulesFlyout-linkText", "data-dyn-title": this.props.Label, "aria-hidden": true, onMouseEnter: this.onmouseenter }, this.props.Label),
                        React.createElement("a", { className: "modulesFlyout-favoriteIcon", "aria-hidden": true, "data-dyn-title": this.favoriteText(), onMouseEnter: this.onmouseenter, onClick: this.clickFavorite }),
                        path));
                };
                return ModuleLink;
            }(DynReact.Navigation));
            UI.ModuleLink = ModuleLink;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModuleLink.js.map
